// src/components/marketplace/Marketplace.js


import React, { useState, useEffect, useMemo } from 'react';
import { Link, Route, Routes } from "react-router-dom";
import { auth } from "../../firebase";
import { Icon } from '@iconify/react';
import _ from 'lodash';


import "./Marketplace.css";

import UserProfilePopup from './UserProfilePopup';
import Profile from './Profile';
import Tooltip from './Tooltip';
import LoadingSpinner from '../../LoadingSpinner';
import { collection, query, where, getDocs } from 'firebase/firestore'; // You may not need all the Firestore functions used in ManageDomains.js
import { dbFirestore } from '../../firebase'; // Import your Firebase Firestore configuration

function Marketplace() {
  const user = auth.currentUser;
  
  const [isLoading, setIsLoading] = useState(true);

  const [displayedText, setDisplayedText] = useState('');
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);
  const [typingFinished, setTypingFinished] = useState(false);

  const sentences = [
    "Companies with job openings 24/7",
    "Location based, remote/ work from home",
    "Click + to view more!"
  ];



  const typingSpeed = isDeleting ? 40 : 80;
  const pauseBetweenSentences = 1500;


  const [isPopupVisible, setPopupVisible] = useState(false);

  const [isProfilePopupVisible, setProfilePopupVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null); // State to manage selected user ID for the popup
  

  const [users, setUsers] = useState([]);
  

  const [publicDomains, setPublicDomains] = useState([]); // Define publicDomains state
  const [posts, setPosts] = useState([]);
  const [allUserDomains, setAllUserDomains] = useState([]); // Define allUserDomains state
  const [selectedCategory, setSelectedCategory] = useState('Industries');
 
  const [isFiltering, setIsFiltering] = useState(false);
  const [showGeneralButton, setShowGeneralButton] = useState(true);


  const [filteredDomainsAll, setFilteredDomainsAll] = useState([]);
  const [nameFilter, setNameFilter] = useState('');
  const [organisationFilter, setOrganisationFilter] = useState('');
  const [locationFilter, setLocationFilter] = useState('');
  const [closingDateFilter, setClosingDateFilter] = useState('');
  const [searchType, setSearchType] = useState('All'); // Default to 'All' for type
  const [searchPostType, setSearchPostType] = useState('All'); // Default to 'All' for type
  const [searchCurrency, setSearchCurrency] = useState('All');
  const [minNumeric, setMinNumeric] = useState('');
  const [maxNumeric, setMaxNumeric] = useState('');
  
  const [searchCategory, setSearchCategory] = useState('All'); // Default to 'All' for category
  
  const [isFilteringActive, setIsFilteringActive] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);


  const [userId, setUserId] = useState(null);

 
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(
    window.innerWidth <= 768 ? 7 : 11 // Default based on screen size
  );

  const itemsPerPage = window.innerWidth <= 768 ? 7 : 11;

  const [randomizedDomains, setRandomizedDomains] = useState([]);
  const [randomizedFilteredDomains, setRandomizedFilteredDomains] = useState([]);

  const [expandedRows, setExpandedRows] = useState({});
  
  const isSmallScreen = window.innerWidth <= 768;
  const [showSmallScreenMenu, setShowSmallScreenMenu] = useState(false);

  const isBigScreen = window.innerWidth >= 981;

  useEffect(() => {
    if (isLoading || typingFinished) return; // 👈 STOP if finished

    const currentSentence = sentences[currentSentenceIndex];

    const handleTyping = () => {
      if (!isDeleting) {
        if (charIndex < currentSentence.length) {
          setDisplayedText(currentSentence.slice(0, charIndex + 1));
          setCharIndex((prev) => prev + 1);
        } else {
          // Done typing current sentence
          if (currentSentenceIndex === sentences.length - 1) {
            // 👇 Stop if it's the LAST sentence
            setTypingFinished(true);
          } else {
            setTimeout(() => setIsDeleting(true), pauseBetweenSentences);
          }
        }
      } else {
        if (charIndex > 0) {
          setDisplayedText(currentSentence.slice(0, charIndex - 1));
          setCharIndex((prev) => prev - 1);
        } else {
          setIsDeleting(false);
          setCurrentSentenceIndex((prev) => prev + 1);
        }
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [charIndex, isDeleting, currentSentenceIndex, isLoading, typingFinished]);


  const getFormattedDate = (dateString) => {
    if (!dateString) return "Various/ Not specified"; // Handle empty or undefined dates
    const date = new Date(dateString);
  
    // Extract day, month, and year
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // e.g., Jan, Feb
    const year = date.getFullYear();
  
    return `${day} ${month} ${year}`;
  };

  const showProfilePopup = (userId) => {
    setSelectedUserId(userId); // Set the selected userId to display in the profile popup
    setPopupVisible(true); // Show the popup
  };


  // Define filter functions

// Filter by name
const filterByOrganisation = (domain, organisationName) => {
  if (!organisationName.trim()) return true; // Return true if no input or only whitespace
  return domain.organisationName?.toLowerCase().includes(organisationName.toLowerCase()) || false;
};

const filterByName = (domain, domainName) => {
  if (!domainName.trim()) return true; // Return true if no input or only whitespace
  return domain.domainName?.toLowerCase().includes(domainName.toLowerCase()) || false;
};

const filterByLocation = (domain, jobLocation) => {
  if (!jobLocation.trim()) return true; // Return true if no input or only whitespace
  return domain.jobLocation?.toLowerCase().includes(jobLocation.toLowerCase()) || false;
};




const filterByClosingDate = (domain, closingDateFilter) => {
  if (!closingDateFilter) return true; // No filter applied if the input is empty

  // Ensure domain.closingDate is valid
  const domainDate = domain.closingDate ? new Date(domain.closingDate) : null;
  if (!domainDate || isNaN(domainDate.getTime())) return false;

  // Convert input filter date to Date object
  const filterDate = new Date(closingDateFilter);

  // Compare the raw dates (not formatted)
  return (
    domainDate.getFullYear() === filterDate.getFullYear() &&
    domainDate.getMonth() === filterDate.getMonth() &&
    domainDate.getDate() === filterDate.getDate()
  );
};





// Filter by type
const filterByType = (domain, type) => {
  return type === 'All' || domain.type === type;
};

const filterByPostType = (domain, postType) => {
  return postType === 'All' || domain.postType === postType;
};


// Filter by currency
const filterByCurrency = (domain, currency) => {
  return currency === 'All' || domain.currency === currency;
};



// Filter by Numeric
const filterByNumericRange = (domain, minNumeric, maxNumeric) => {
  const domainNumeric = parseFloat(domain.numeric);
  console.log('Parsed Domain Numeric:', domainNumeric);

  const isMinNumericValid = minNumeric === '' || domainNumeric >= parseFloat(minNumeric);
  console.log('Is Min Numeric Valid:', isMinNumericValid);

  const isMaxNumericValid = maxNumeric === '' || domainNumeric <= parseFloat(maxNumeric);
  console.log('Is Max Numeric Valid:', isMaxNumericValid);

  return isMinNumericValid && isMaxNumericValid;
};





// Filter by category
const filterByCategory = (domain, category) => {
  return category === 'All' || domain.category === category;
};


const applyFilters = () => {
  const filtered = allDomains.filter((domain) => {
    const matchesName = filterByName(domain, nameFilter);
    const matchesOrganisation = filterByOrganisation(domain, organisationFilter);
    const matchesLocation = filterByLocation(domain, locationFilter);
    const matchesClosingDate = filterByClosingDate(domain, closingDateFilter);
    const matchesType = filterByType(domain, searchType);
    const matchesPostType = filterByPostType(domain, searchPostType);
    const matchesCurrency = filterByCurrency(domain, searchCurrency);
    const matchesNumeric = filterByNumericRange(domain, minNumeric, maxNumeric);
    const matchesCategory = filterByCategory(domain, searchCategory);

    

    return matchesName && matchesOrganisation && matchesLocation && matchesClosingDate && matchesType && matchesPostType && matchesNumeric && matchesCategory && matchesCurrency;

  });

  setFilteredDomainsAll(filtered);

  setStartIndex(0);
  setEndIndex(itemsPerPage);
};



// Combine public domains and domains from all users
const allDomains = [...publicDomains, ...allUserDomains];


  useEffect(() => {
    console.log("UseEffect: Fetching data...");

    // 1. Fetch all public domains from top-level /domains
    const fetchPublicDomains = async () => {
      try {
        const publicDomainsRef = collection(dbFirestore, 'domains');
        const publicQuerySnapshot = await getDocs(publicDomainsRef);
        const publicDomainsData = publicQuerySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPublicDomains(publicDomainsData);
      } catch (error) {
        console.error('Error fetching public domains:', error);
      }
    };

    // 2. Fetch public domains from all users AND public WP posts
    const fetchAllUserDomains = async () => {
      try {
        const allUserDomains = [];

        // Fetch users from Firestore
        const usersRef = collection(dbFirestore, 'users');
        const userQuerySnapshot = await getDocs(usersRef);
        const userDocs = userQuerySnapshot.docs;

        // For each user, fetch their public domains
        for (const userDoc of userDocs) {
          const userUid = userDoc.id;
          const userDomainsRef = collection(dbFirestore, 'users', userUid, 'domains');
          const publicDomainsQuery = query(userDomainsRef, where('isPublic', '==', true));
          const publicDomainsSnapshot = await getDocs(publicDomainsQuery);

          const userDomainsData = publicDomainsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          allUserDomains.push(...userDomainsData);
        }

   {/*}     // Also fetch public posts from /posts
        const postsRef = collection(dbFirestore, 'posts');
        const postsSnapshot = await getDocs(postsRef);
        const publicPosts = postsSnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((post) => post.isPublic === true);

          

        // Combine both into one dataset
        allUserDomains.push(...publicPosts);

        */}

        // Set to state
        setAllUserDomains(allUserDomains);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching public user domains or posts:', error);
        setIsLoading(false);
      }
    };

    fetchPublicDomains();     // Top-level /domains
    fetchAllUserDomains();    // /users/*/domains + /posts
  }, []);

  
 {/* 
  // Marketplace.js
useEffect(() => {
  console.log("UseEffect 1: Fetching data...");
  // Fetch all public domains
  const fetchPublicDomains = async () => {
    try {
      const publicDomainsRef = collection(dbFirestore, 'domains');
      const publicQuerySnapshot = await getDocs(publicDomainsRef);
      const publicDomainsData = publicQuerySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPublicDomains(publicDomainsData);
    } catch (error) {
      console.error('Error fetching public domains:', error);
    }
  };

  // Fetch domains from all users (including public domains)
  const fetchAllUserDomains = async () => {
    try {
      const allUserDomains = [];
  
      // Fetch users from Firestore
      const usersRef = collection(dbFirestore, 'users');
      const userQuerySnapshot = await getDocs(usersRef);
      const userDocs = userQuerySnapshot.docs;
  
      // Iterate over each user and fetch only public domains
      for (const userDoc of userDocs) {
        const userUid = userDoc.id;
        const userDomainsRef = collection(dbFirestore, 'users', userUid, 'domains');
  
        // Query to get only domains where isPublic is true
        const publicDomainsQuery = query(userDomainsRef, where('isPublic', '==', true));
        const publicDomainsSnapshot = await getDocs(publicDomainsQuery);
  
        const userDomainsData = publicDomainsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
  
        allUserDomains.push(...userDomainsData);
      }
  
      setAllUserDomains(allUserDomains);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching public user domains:', error);
      setIsLoading(false);
    }
  };
  

  fetchPublicDomains(); // Fetch all public domains
  fetchAllUserDomains(); // Fetch domains from all users


    
}, []);

*/}

// to see users of this app
useEffect(() => {
  const fetchUsers = async () => {
    try {
      const usersRef = collection(dbFirestore, 'users');
      const usersSnapshot = await getDocs(usersRef);
      const usersData = usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(usersData);
    
    } catch (error) {
      console.error('Error fetching users:', error);
      
    }
  };

  fetchUsers();
}, []);


const [currentDomainIndex, setCurrentDomainIndex] = useState(0);

useEffect(() => {
  const rotateDomains = () => {
    setCurrentDomainIndex((prevIndex) => (prevIndex + 1) % allDomains.length);
  };

  const rotationInterval = 5000; // Rotate every 5 seconds (adjust as needed)

  const rotationTimer = setInterval(rotateDomains, rotationInterval);

  return () => {
    clearInterval(rotationTimer); // Clear the interval when the component unmounts or dependencies change
  };
}, [allDomains]);

const currentDomain = allDomains[currentDomainIndex];

const [currentRowIndex, setCurrentRowIndex] = useState(0);


useEffect(() => {
  const rotateRows = () => {
    setCurrentRowIndex((prevIndex) => (prevIndex + 1) % allDomains.length);
  };

  const rotationInterval = 5000; // Rotate every 5 seconds (adjust as needed)

  const rotationTimer = setInterval(rotateRows, rotationInterval);

  return () => {
    clearInterval(rotationTimer); // Clear the interval when the component unmounts or dependencies change
  };
}, [allDomains]);

const currentRow = allDomains[currentRowIndex];


useEffect(() => {
  if (allDomains.length > 0 && randomizedDomains.length === 0) {
    const shuffled = [...allDomains].sort(() => 0.5 - Math.random());
    setRandomizedDomains(shuffled);
  }
}, [allDomains]); // Runs only when `allDomains` changes




  const renderAllDomainsTable = ({ showGeneralButton, isFilteringActive, toggleFiltering }) => {  
  
    


  const tableStyle = {
    borderCollapse: 'collapse',
    width: '100%',
  };

  const thStyle = {
    backgroundColor: '#f0f0f0',
    padding: '8px',
    textAlign: 'left',
    borderBottom: '1px solid #ddd',
  
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '200px', // Default maxWidth for larger screens
  };

  const tdStyle = {
    padding: '8px',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '200px', // Default maxWidth for larger screens
  };

  // Media query to adjust styles for smaller screens
  if (window.innerWidth <= 768) {
    tdStyle.maxWidth = '120px'; // Adjust maxWidth for smaller screens
    thStyle.maxWidth = '150px'; // Adjust maxWidth for smaller screens
  }

  const categoriesbtnStyle = {
    margin: '5px',
    padding: '6px 12px',
    fontSize: '12px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#4f4f4f',
    color: 'white',
    cursor: 'pointer',
    textAlign: 'right'
  };

  const filterbtnStyle = {
    margin: '5px',
    padding: '6px 12px',
    fontSize: '12px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#4f4f4f',
    color: 'white',
    cursor: 'pointer'
  };

  const TooltipbtnStyle = {
    backgroundColor: '#eeeeee',
    color: '#000000',
    padding: '2px 4px', // Adjust padding as needed for your content
    border: 'none',
    borderRadius: '5px', // Border radius for rounded corners
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center', // Center content vertically
    justifyContent: 'center', // Center content horizontally
   
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Optional box shadow for a raised effect
  };

  const RegistrarbtnStyle = {
    textDecoration: 'underline', 
  }

  

  const applyBtnStyle = (isDisabled) => ({
    backgroundColor: isDisabled ? '#d3d3d3' : '#007bff',
    color: isDisabled ? '#6c757d' : '#fff',
    padding: '2px 4px',
    border: 'none',
    borderRadius: '5px',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    textAlign: 'left'
  });


  const NxtNavbuttonStyle = {

  position: 'absolute',

  right: '10px',
 
  
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'right', 
 
    margin: '0 5px', // Margin between buttons
    padding: '8px', // Padding inside buttons
    cursor: 'pointer', // Cursor style
  };

  const PreNavbuttonStyle = {

    position: 'absolute',

  right: '40px',
 
  
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'right', 
 
    margin: '0 5px', // Margin between buttons
    padding: '8px', // Padding inside buttons
    cursor: 'pointer', // Cursor style
  };
  
  const disabledNxtNavButtonStyle = {
    ...NxtNavbuttonStyle,

    cursor: 'not-allowed', // Change cursor to not-allowed for disabled buttons
    color: 'grey', // Set text color to grey for disabled buttons

  alignItems: 'center',
  justifyContent: 'center',
  };

  const disabledPreNavButtonStyle = {
    ...PreNavbuttonStyle,

    cursor: 'not-allowed', // Change cursor to not-allowed for disabled buttons
    color: 'grey', // Set text color to grey for disabled buttons

  alignItems: 'center',
  justifyContent: 'center',
  };
  
  
  const NaviconStyle = {
    marginRight: '5px', // Margin between icon and text
  };




  const handleGeneralButtonClick = () => {
    setShowGeneralButton(!showGeneralButton);

    // Toggle filtering when the button is clicked
    toggleFiltering(!isFilteringActive);
  };

  const handlePreviousPage = () => {
    const newStartIndex = Math.max(startIndex - itemsPerPage, 0);
    setStartIndex(newStartIndex);
    setEndIndex(newStartIndex + itemsPerPage);
  };
  
  const handleNextPage = () => {
    const newStartIndex = endIndex;
    setStartIndex(newStartIndex);
    setEndIndex(newStartIndex + itemsPerPage);
  };
  


  const filteredDomainsToRender = isFilteringActive ? filteredDomainsAll : allDomains;

  const domainsToDisplay = isFilteringActive
  ? filteredDomainsToRender.slice(startIndex, endIndex)
  : randomizedDomains.slice(startIndex, endIndex);

    
  const toggleRowExpansion = (domainId) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [domainId]: !prevExpandedRows[domainId],
    }));
  };

  const isSmallScreen = window.innerWidth <= 768;

  const stickyContainerStyle = {
    position: 'sticky',
    top: '10px', // Adjust as needed
    background: 'white', // Ensures the background stays visible
    zIndex: 1000, // Keeps it above other elements
    padding: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center'
};

  

const handleRefresh = () => {
  window.location.reload();
};


  return (
    <div>
      


<div style={stickyContainerStyle}>
<button onClick={handleRefresh} >
  <Icon icon="mdi:refresh-circle" color="black" width="19" height="19" style={NaviconStyle}/> 
    </button>
    <button style={filterbtnStyle} onClick={() => setIsFilteringActive(!isFilteringActive)}>
                {isFilteringActive ? "Show All Jobs" : isBigScreen ? "Search and Apply Filter" : "Search"}
            </button>
    
    {!isFilteringActive && (
       <button style={categoriesbtnStyle} onClick={() => setShowGeneralButton(false)}>
                {isBigScreen ? "All Available Industries" : "Industries"}
            </button>
    )}

    
       
    <button
  style={startIndex <= 0 ? disabledPreNavButtonStyle : PreNavbuttonStyle}
  onClick={handlePreviousPage}
  disabled={startIndex <= 0}
>
  <Icon icon="carbon:previous-filled" color={startIndex <= 0 ? 'grey' : 'black'} width="24" height="24" style={NaviconStyle} />

</button>

<button
  style={endIndex >= (isFilteringActive ? filteredDomainsToRender.length : allDomains.length) ? disabledNxtNavButtonStyle : NxtNavbuttonStyle}
  onClick={handleNextPage}
  disabled={endIndex >= (isFilteringActive ? filteredDomainsToRender.length : allDomains.length)}
>
  
  <Icon icon="carbon:next-filled" color={endIndex >= (isFilteringActive ? filteredDomainsToRender.length : allDomains.length) ? 'grey' : 'black'} width="24" height="24" style={NaviconStyle} />
</button>
    

   
</div>
   

<table style={tableStyle}>
        <thead>
          <tr>
          <th style={thStyle}>Organisation</th>
            <th style={thStyle}>Job title</th>
         
           {/* <th style={thStyle}>Job information</th>*/}
            
            {isSmallScreen && <th style={thStyle}></th>}
            {!isSmallScreen && (
              <>
                <th style={thStyle}>Annual Salary</th>
                <th style={thStyle}>Employment Type</th>
                <th style={thStyle}>Industry</th>
                <th style={thStyle}>Location</th>
                <th style={thStyle}>Closing date</th>
                <th style={thStyle}>View</th>
               {/* <th style={thStyle}>About</th>*/}
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={isSmallScreen ? '2' : '8'}><LoadingSpinner /></td>
            </tr>
          ) : (
            domainsToDisplay.map((domain) => {
              const rows = [
                <tr key={domain.id}>
                  <td style={tdStyle}><strong>{domain.organisationName}</strong></td>
                  <td style={tdStyle}><strong>{domain.domainName}</strong></td>
                           
                  {isSmallScreen && (
                    <td style={tdStyle}>
                      <button 
                       style={{
                        backgroundColor: expandedRows[domain.id] ? 'blue' : 'blue',
                        color: 'white',
                        padding: '0px 8px',
                        border: 'none',
                        borderRadius: '5px',
                      }}
                      onClick={() => toggleRowExpansion(domain.id)}>
                        {expandedRows[domain.id] ? '-' : '+'}
                      </button>
                    </td>
                  )}
                  {!isSmallScreen && (
                    <>
                     <td style={tdStyle}><strong>{domain.currency}{domain.numeric}</strong></td>
                 {/*   <td style={{ padding: '8px', borderBottom: '1px solid #ddd', backgroundColor: '#ffffff', overflow: 'visible', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px', }}>
                        <Tooltip text={domain.description || 'No further info on job'}>
                          <button style={TooltipbtnStyle}>Read job information</button>
                        </Tooltip>
                      </td> */}
                      <td style={tdStyle}>{domain.type}</td>
                      
                      
                     
                      <td style={tdStyle}>{domain.category}</td>
                      <td style={tdStyle}>{domain.jobLocation}</td>
                      <td style={tdStyle}>{getFormattedDate(domain.closingDate)}</td>
                      <td style={tdStyle}>
                    

                    <button
  style={applyBtnStyle(!domain.jobUrl)}
  disabled={!domain.jobUrl}
  onClick={() => window.open(domain.jobUrl, "_blank", "noopener,noreferrer")}
>
  Job Link
</button>
                    
                  </td>
                  {/*}
                  <td style={tdStyle}>
                        <button onClick={() => showProfilePopup(domain.ownerId || 'defaultUserId')}>
                          <Icon icon="akar-icons:info-fill" width="24" height="24" />
                        </button>
                      </td>*/}
                    </>
                  )}
                </tr>
              ];

              if (isSmallScreen && expandedRows[domain.id]) {
                rows.push(
                  <tr key={`${domain.id}-expanded`}>
                    <td colSpan={isSmallScreen ? '2' : '8'}>
                      <div>
                      <p style={{ color: 'grey', textAlign: 'center', lineHeight: '1.5' }}>
  <strong>{domain.domainName}</strong>
</p>
{/*<p><strong>Description:</strong> {domain.description ? domain.description : 'No further info on job'}</p> */}
                        <p>
                        <p><strong>Type:</strong> {domain.type}</p>
                        <p><strong>Annual Salary:</strong> {domain.currency} {domain.numeric}</p>
                        <p><strong>Industry:</strong> {domain.category}</p>
                        <p><strong>Location:</strong> {domain.jobLocation}</p>
                        <p><strong>Closing Date:</strong> {getFormattedDate(domain.closingDate)}</p>
                        <p><strong>View: </strong>

                    <button
  style={applyBtnStyle(!domain.jobUrl)}
  disabled={!domain.jobUrl}
  onClick={() => window.open(domain.jobUrl, "_blank", "noopener,noreferrer")}
>
  Job Link
</button>
                    </p>
  {/*<strong>About:</strong>{" "}
  <span
    style={{
      cursor: "pointer",
     
      color: "blue",
    }}
    onClick={() => showProfilePopup(domain.ownerId || "defaultUserId")}
  >
    View Profile
  </span>*/}
</p>
                      
                       
                        <p><strong>Organisation:</strong> {domain.organisationName}</p>

                      </div>
                    </td>
                  </tr>
                );
              }

              return rows;
            })
          )}
        </tbody>
      </table>
      
      

      {isPopupVisible && (
        <div className="user-profile-popup">
          <Profile userId={selectedUserId} onClose={() => setPopupVisible(false)} />
        </div>
      )}
    </div>
  );
};



const filteredDomains = useMemo(() => {
  console.log("Calculating filtered domains based on selectedCategory and allDomains:", selectedCategory, allDomains);
  return selectedCategory
    ? allDomains.filter((domain) => domain.category === selectedCategory)
    : allDomains;
}, [selectedCategory, allDomains]);


useEffect(() => {
  if (filteredDomains.length > 0) {
    // Ensure we don't re-randomize the same data
    setRandomizedFilteredDomains((prev) => {
      if (prev.length > 0 && prev.every((domain, index) => domain.id === filteredDomains[index]?.id)) {
        return prev; // Prevent unnecessary state updates
      }
      return [...filteredDomains].sort(() => Math.random() - 0.5);
    });
  } else {
    setRandomizedFilteredDomains([]); // Reset when there's no result
  }
}, [filteredDomains.length, selectedCategory]);


// Inside the renderDomainList function, update the button as follows:
const renderDomainList = () => {
 

    const tableStyle = {
      borderCollapse: 'collapse', // Collapse table borders
      width: '100%', // Make the table take up the available width
    };
    
   
    const thStyle = {
      backgroundColor: '#f0f0f0',
      padding: '8px',
      textAlign: 'left',
      borderBottom: '1px solid #ddd',
    
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '200px', // Default maxWidth for larger screens
    };

    const tdStyle = {
      padding: '8px',
      borderBottom: '1px solid #ddd',
      backgroundColor: '#ffffff',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '200px', // Default maxWidth for larger screens
    };
  
    // Media query to adjust styles for smaller screens
    if (window.innerWidth <= 768) {
      tdStyle.maxWidth = '100px'; // Adjust maxWidth for smaller screens
      thStyle.maxWidth = '150px'; // Adjust maxWidth for smaller screens
    }

    const closePopupStyle = {
      position: 'absolute',
      top: '10px', // Adjust the top position according to your design
      right: '10px', // Adjust the right position according to your design
      cursor: 'pointer', // Add a pointer cursor to indicate it's clickable
    };

    const TooltipbtnStyle = {
      backgroundColor: '#eeeeee',
      color: '#000000',
      padding: '2px 4px', // Adjust padding as needed for your content
      border: 'none',
      borderRadius: '5px', // Border radius for rounded corners
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center', // Center content vertically
      justifyContent: 'center', // Center content horizontally
     
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Optional box shadow for a raised effect
    };

    const RegistrarbtnStyle = {
      textDecoration: 'underline', 
    }

    const applyBtnStyle = (isDisabled) => ({
      backgroundColor: isDisabled ? '#d3d3d3' : '#007bff',
      color: isDisabled ? '#6c757d' : '#fff',
      padding: '2px 4px',
      border: 'none',
      borderRadius: '5px',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      textAlign: 'left'
    });

    const stickyContainerStyle = {
      position: 'sticky',
      top: '10px', // Adjust as needed
      background: 'white', // Ensures the background stays visible
      zIndex: 1000, // Keeps it above other elements
      padding: '10px',
      display: 'flex',
      gap: '10px',
      alignItems: 'center'
  };
  



    const filteredDomainsToDisplay = randomizedFilteredDomains.slice(startIndex, endIndex);

    const toggleRowExpansion = (domainId) => {
      setExpandedRows((prevExpandedRows) => ({
        ...prevExpandedRows,
        [domainId]: !prevExpandedRows[domainId],
      }));
    };
  
    const isSmallScreen = window.innerWidth <= 768;

    
    const handleCategoryClick = (category) => {
      setSelectedCategory(category);
      setIsFiltering(!!category); // Set isFiltering to true if category is selected, otherwise false

      setStartIndex(0);
      setEndIndex(itemsPerPage);

      if (isSmallScreen) {
        setShowSmallScreenMenu(false);
      }
    };
  
    const toggleSmallScreenMenu = () => {
      setShowSmallScreenMenu(!showSmallScreenMenu);
    };

 
  return (

    <div>
      
        {!showGeneralButton && (
          
          <div>
          {isSmallScreen && (
            <div className={`menu-icon ${showSmallScreenMenu ? 'active' : ''}`} onClick={toggleSmallScreenMenu}>
              ☰ Menu {/* Hamburger menu icon */}
            </div>
          )}
          {showSmallScreenMenu && isSmallScreen && (
            <div className="category-buttons">
              <button onClick={() => handleCategoryClick('Government')}>Government/ Public Sector</button>
               <button onClick={() => handleCategoryClick('Retail')}>Retail</button>
               <button onClick={() => handleCategoryClick('Banking')}>Banking</button>
               <button onClick={() => handleCategoryClick('Mining')}>Mining</button>
               <button onClick={() => handleCategoryClick('Technology')}>Technology</button>
               
               <button onClick={() => handleCategoryClick('Telecommunication')}>Telecommunication</button>

         {/*}     <button onClick={() => handleCategoryClick('Sport')}>Sport</button>
              <button onClick={() => handleCategoryClick('Entertainment')}>Entertainment</button>
        <button onClick={() => handleCategoryClick('Blog')}>Blog</button>
        <button onClick={() => handleCategoryClick('Finance')}>Finance</button>
        <button onClick={() => handleCategoryClick('Travel and Hospitality')}>Travel</button>
        <button onClick={() => handleCategoryClick('Education and Academic')}>Education and Academic</button>
        <button onClick={() => handleCategoryClick('Health')}>Health</button>
        
        <button onClick={() => handleCategoryClick('Internet services')}>Internet services</button>
        <button onClick={() => handleCategoryClick('Design')}>Design</button>
        <button onClick={() => handleCategoryClick('E-commerce')}>E-commerce</button>
        <button onClick={() => handleCategoryClick('Business')}>Business</button>
        <button onClick={() => handleCategoryClick('Non-profit')}>Non-profit</button>
        <button onClick={() => handleCategoryClick('Other')}>Other</button>  
        
              {/* Add more category buttons as needed */}
            </div>
          )}
          {!isSmallScreen && (
            <div className="category-buttons">
              <h4>Industries</h4>
              <div style={{ display: 'flex', justifyContent: 'space-around', margin: '1px',  }}>
              
              <button onClick={() => handleCategoryClick('Government')}>Government/ Public Sector</button>
              <button onClick={() => handleCategoryClick('Retail')}>Retail</button>
              <button onClick={() => handleCategoryClick('Banking')}>Banking</button>
              <button onClick={() => handleCategoryClick('Mining')}>Mining</button>
              <button onClick={() => handleCategoryClick('Technology')}>Technology</button>
             
              <button onClick={() => handleCategoryClick('Telecommunication')}>Telecommunication</button>
              
              
      {/*}  
      <button onClick={() => handleCategoryClick('Sport')}>Sport</button>
      <button onClick={() => handleCategoryClick('Entertainment')}>Entertainment</button>
      <button onClick={() => handleCategoryClick('Blog')}>Blog</button>
        <button onClick={() => handleCategoryClick('Finance')}>Finance</button>
        <button onClick={() => handleCategoryClick('Travel and Hospitality')}>Travel</button>
        <button onClick={() => handleCategoryClick('Education and Academic')}>Education and Academic</button>
        <button onClick={() => handleCategoryClick('Health')}>Health</button>
       
        <button onClick={() => handleCategoryClick('Internet services')}>Internet services</button>
        <button onClick={() => handleCategoryClick('Design')}>Design</button>
        <button onClick={() => handleCategoryClick('E-commerce')}>E-commerce</button>
        <button onClick={() => handleCategoryClick('Business')}>Business</button>
        <button onClick={() => handleCategoryClick('Non-profit')}>Non-profit</button>
        <button onClick={() => handleCategoryClick('Other')}>Other</button>  
              {/* Add more category buttons as needed */}
            </div>
            </div>
          )}
        </div>
      )}
    <table style={tableStyle}>
        <thead>
          <tr>
          <th style={thStyle}>Organisation</th>
            <th style={thStyle}>Job title</th>
            
          {/*  <th style={thStyle}>Job information</th> */}
            {isSmallScreen && <th style={thStyle}></th>}
            {!isSmallScreen && (
              <>
              <th style={thStyle}>Annual Salary</th>
                <th style={thStyle}>Employment Type</th>
                
                <th style={thStyle}>Location</th>
                <th style={thStyle}>Closing date</th>
                <th style={thStyle}>View</th>
              {/* <th style={thStyle}>About</th> */}  
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={isSmallScreen ? '2' : '8'}><LoadingSpinner /></td>
            </tr>
          ) : (
            filteredDomainsToDisplay.map((domain) => {
              const rows = [
                <tr key={domain.id}>
                  <td style={tdStyle}><strong>{domain.organisationName}</strong></td>
                  <td style={tdStyle}><strong>{domain.domainName}</strong></td>
                  
                  
                  {isSmallScreen && (

                    <td style={tdStyle}>
                      <button 
                       style={{
                        backgroundColor: expandedRows[domain.id] ? 'blue' : 'blue',
                        color: 'white',
                        padding: '4px 8px',
                        border: 'none',
                        borderRadius: '5px',
                      }}
                      onClick={() => toggleRowExpansion(domain.id)}>
                        {expandedRows[domain.id] ? '-' : '+'}
                      </button>
                    </td>
                  )}
                  {!isSmallScreen && (
                    <>
                    {/*
                     <td style={{ padding: '8px', borderBottom: '1px solid #ddd', backgroundColor: '#ffffff', overflow: 'visible', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px', }}>
                        <Tooltip text={domain.description || 'No further info on job'}>
                          <button style={TooltipbtnStyle}>Read description</button>
                        </Tooltip>
                      </td>*/}
                      <td style={tdStyle}><strong>{domain.currency}{domain.numeric}</strong></td>
                      <td style={tdStyle}>{domain.type}</td>
                      <td style={tdStyle}>{domain.jobLocation}</td>
                      <td style={tdStyle}>{getFormattedDate(domain.closingDate)}</td>
                      <td style={tdStyle}>

                    
                    
                  
                  </td>
             {/*}     <td style={tdStyle}>
                        <button onClick={() => showProfilePopup(domain.ownerId || 'defaultUserId')}>
                          <Icon icon="akar-icons:info-fill" width="24" height="24" />
                        </button>
                      </td> */}
                    </>
                  )} 
                </tr>
              ];

              if (isSmallScreen && expandedRows[domain.id]) {
                rows.push(
                  <tr key={`${domain.id}-expanded`}>
                    <td colSpan={isSmallScreen ? '2' : '8'}>
                      <div>
                      <p style={{ color: 'grey', textAlign: 'center', lineHeight: '1.5' }}>
                      
  <strong>{domain.domainName}</strong>
</p>
                        
                      {/*  <p><strong>Description:</strong> {domain.description ? domain.description : 'No description is provided'}</p> */}
                        <p>
                        <p><strong>Employment Type:</strong> {domain.type}</p>
                        <p><strong>Annual Salary:</strong> {domain.currency} {domain.numeric}</p>
                        <p><strong>Industry:</strong> {domain.category}</p>
                        <p><strong>Location:</strong> {domain.jobLocation}</p>
                        <p><strong>Closing Date:</strong> {getFormattedDate(domain.closingDate)}</p>
                        <p><strong>View: </strong> 

                    <button
  style={applyBtnStyle(!domain.jobUrl)}
  disabled={!domain.jobUrl}
  onClick={() => window.open(domain.jobUrl, "_blank", "noopener,noreferrer")}
>
  Job Link
</button>
                    </p>
  {/*<strong>About:</strong>{" "}
  <span
    style={{
      cursor: "pointer",
     
      color: "blue",
    }}
    onClick={() => showProfilePopup(domain.ownerId || "defaultUserId")}
  >
    View Profile
  </span>
  */}
</p>
                      
                       
                        <p><strong>Organisation:</strong> {domain.organisationName}</p>
                      </div>
                    </td>
                  </tr>
                );
              }

              return rows;
            })
          )}
        </tbody>
      </table>
      

      {isPopupVisible && (
        <div className="user-profile-popup">
          <Profile userId={selectedUserId} onClose={() => setPopupVisible(false)} />
        </div>
      )}
    </div>
  );
};



const allDomainsbtnStyle = {
  margin: '5px',
  padding: '6px 12px',
  fontSize: '12px',
  border: 'none',
  borderRadius: '5px',
  backgroundColor: '#4f4f4f',
  color: 'white',
  cursor: 'pointer'
};

const formatNumber = (number) => {
  return number.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};


const formattedMinValue = formatNumber(minNumeric);
const formattedMaxValue = formatNumber(maxNumeric);


const NxtNavbuttonStyle = {

  position: 'fixed',

  right: '10px',
 
  
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'right', 
 
    margin: '0 5px', // Margin between buttons
    padding: '8px', // Padding inside buttons
    cursor: 'pointer', // Cursor style
  };

  const PreNavbuttonStyle = {

    position: 'fixed',

  right: '40px',
 
  
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'right', 
 
    margin: '0 5px', // Margin between buttons
    padding: '8px', // Padding inside buttons
    cursor: 'pointer', // Cursor style
  };
  
  const disabledNxtNavButtonStyle = {
    ...NxtNavbuttonStyle,

    cursor: 'not-allowed', // Change cursor to not-allowed for disabled buttons
    color: 'grey', // Set text color to grey for disabled buttons

  alignItems: 'center',
  justifyContent: 'center',
  };

  const disabledPreNavButtonStyle = {
    ...PreNavbuttonStyle,

    cursor: 'not-allowed', // Change cursor to not-allowed for disabled buttons
    color: 'grey', // Set text color to grey for disabled buttons

  alignItems: 'center',
  justifyContent: 'center',
  };
  
  
  const NaviconStyle = {
    marginRight: '5px', // Margin between icon and text
  };

  const stickyContainerStyle = {
    position: 'sticky',
    top: '10px', // Adjust as needed
    background: 'white', // Ensures the background stays visible
    zIndex: 1000, // Keeps it above other elements
    padding: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center'
};


  const handlePreviousPage = () => {
    const newStartIndex = Math.max(startIndex - itemsPerPage, 0);
    setStartIndex(newStartIndex);
    setEndIndex(newStartIndex + itemsPerPage);
  };
  
  const handleNextPage = () => {
    const newStartIndex = endIndex;
    setStartIndex(newStartIndex);
    setEndIndex(newStartIndex + itemsPerPage);
  };

  const clearFilters = () => {
    // Reset all filters
    setSearchPostType("All");
    setOrganisationFilter("");
    setNameFilter("");
    setSearchCurrency("All");
    setMinNumeric("");
    setMaxNumeric("");
    setSearchCategory("All");
    setSearchType("All");
    setLocationFilter("");
    setClosingDateFilter("");
  
  };

  const typingTextStyle = {
    fontSize: '18px',
    fontWeight: '500',
    color: '#333',
    marginTop: '15px',
    marginLeft: '10px'
  };

  const blinkingCursorStyle = {
    display: 'inline-block',
    animation: 'blink 1s step-start infinite'
  };  

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    
      <div style={{ backgroundColor: '#ffffff', padding: '0px' }}>
        
        {isBigScreen && (
        <header>
      <div style={{ backgroundColor: '#ffffff', padding: '0px' }}>
        <div style={{ backgroundColor: '#389FA6', borderRadius: '8px', padding: '10px', display: 'inline-block' }}>
          <h2 style={{ margin: '0', color: '#ffffff', fontSize: '14px' }}>SP COMMUNITY</h2> 
        </div>
      </div>
    </header>
     )}
     <div style={typingTextStyle}>
        {displayedText}
        <span style={blinkingCursorStyle}>|</span>

      </div>
      
      {isFilteringActive && (
      <div className="domain-filter">
      {/* Search inputs */}
      <button 
  onClick={() => {
    setSearchPostType("Various Positions");
    applyFilters(); // Apply filter immediately
  }}
>
Show only Companies/ Organisations that are always hiring 
</button> 
      <input
  type="text"
  placeholder="Organisation"
  value={organisationFilter}
  onChange={(e) => setOrganisationFilter(e.target.value)}
/>    
      <input
  type="text"
  placeholder="Job title"
  value={nameFilter}
  onChange={(e) => setNameFilter(e.target.value)}
/>

<select value={searchPostType} onChange={(e) => setSearchPostType(e.target.value)}>
        
        <option value="All">Select Post Type</option>
          <option value="Various Positions">Companies/ Organisations always hiring</option>
          <option value="Specific Position">Specific Position</option>
         
        {/* Add options for domain types */}
      </select>
     {/*}
      
      <select value={searchCurrency} onChange={(e) => setSearchCurrency(e.target.value)}>
          <option value="All">Select Currency</option>
          <option value="R">R /South African Rand</option>
          <option value="$">$/ USD /US Dollar</option>
          <option value="€">€/ EUR /Euro</option>
          <option value="£">£/ GBP /British Pound</option>
          <option value="¥">¥ /Yen</option>
          <option value="₣">₣ /Franc</option>
          <option value="₹">₹ /Rupee</option>
          <option value="₽">₽ /RUB /Russian Ruble</option>
          <option value="A$">A$ /AUD /Australian Dollar</option>
          <option value="C$">C$ /CAD /Canadian dollar</option>
          <option value="HK$">HK$ /Hong Kong Dollar</option>
          <option value="R$">R$ /BRL /Brazilian real</option>
          <option value="Mex$">Mex$ /MXN /Mexican Peso</option>
          <option value="د.إ"> د.إ /Dirham</option>
          <option value="د.ك"> د.ك /Dinar</option>
          <option value="Multiple">Multiple</option>
          
      </select>
      
 
      <input
  type="text"
  placeholder="Min annual pay"
  value={minNumeric === '' ? '' : minNumeric.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
  })}
  onChange={(e) => {
    const enteredValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (enteredValue === '') {
      setMinNumeric(''); // Handle empty input by setting the value to an empty string
    } else if (!isNaN(enteredValue)) {
      setMinNumeric(parseInt(enteredValue, 10));
    }
    // If you want to handle invalid input differently, you can add an else block here.
  }}
/>


<input
  type="text"
  placeholder="Max annual pay"
  value={maxNumeric === '' ? '' : maxNumeric.toLocaleString('en-US', {
    style: 'decimal',
    maximunFractionDigits: 0,
  })}
  onChange={(e) => {
    const enteredValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (enteredValue === '') {
      setMaxNumeric(''); // Handle empty input by setting the value to an empty string
    } else if (!isNaN(enteredValue)) {
      setMaxNumeric(parseInt(enteredValue, 10));
    }
    // If you want to handle invalid input differently, you can add an else block here.
  }}
/>

*/}

      <select value={searchCategory} onChange={(e) => setSearchCategory(e.target.value)}>
        <option value="All">All Industries</option>
        <option value="Government">Government/ Public Sector</option>
        <option value="Retail">Retail</option>
        <option value="Banking">Banking</option>
        <option value="Mining">Mining</option>
        <option value="Telecommunication">Telecommunication</option>
        <option value="Technology">Technology</option>
       
        
    {/*}    
      <option value="Sport">Sport</option>
          <option value="Entertainment">Entertainment</option>
          <option value="Blog">Blog</option>
          <option value="Finance">Finance</option>
          <option value="Travel and Hospitality">Travel and Hospitality</option>
          <option value="Education and Academic">Education and Academic</option>
          <option value="Health">Health</option>
          
          <option value="Internet services">Internet services</option>
          <option value="Design">Design</option>
          <option value="E-commerce and Online Stores">E-commerce and Online Stores</option>
          <option value="Business">Business</option>
          <option value="Non-profit">Non-profit</option>
          <option value="Other">Other</option>
        {/* Add options for domain categories */}
      </select>
      
      <select value={searchType} onChange={(e) => setSearchType(e.target.value)}>
        <option value="All">All Employment Types</option>
        <option value="Full-Time">Full-Time</option>
          <option value="Part-Time">Part-Time</option>
          <option value="Freelance">Freelance</option>
          <option value="Contract">Contract</option>
          <option value="Internship">Internship</option>
          <option value="Learnership">Learnership</option>
          </select>
       {/* Button to activate/deactivate filtering */}
       <input
  type="text"
  placeholder="Location"
  value={locationFilter}
  onChange={(e) => setLocationFilter(e.target.value)}
/>    

<input
  type="date"
  placeholder="Closing date"
  value={closingDateFilter || ""} // Ensure empty string if no filter is set
  onChange={(e) => setClosingDateFilter(e.target.value)}
/>

  
       
<button onClick={applyFilters}disabled={filtersApplied} style={{ backgroundColor: filtersApplied ? "#ccc" : "#007bff" }}>Apply Filter</button><button onClick={clearFilters}>Clear Filter</button>


      {/* ... Rest of your rendering logic ... */}

    </div>
    )}
    
    
<div>
   
    
</div>


      
      {/* Other content */}
      
      {/* Display the list of domains */}

      {/* Conditionally render the "Geno" button */}
    

<div>
  
      {showGeneralButton ? (
        <>
          
          {renderAllDomainsTable({ showGeneralButton, isFilteringActive, toggleFiltering: setIsFilteringActive })}
        </>
      ) : (
        <>
        <div>

<button style={allDomainsbtnStyle} onClick={() => setShowGeneralButton(true)}>
            <h4>All Jobs</h4>
        </button>
        
        <button
        style={startIndex <= 0 ? disabledPreNavButtonStyle : PreNavbuttonStyle}
        onClick={handlePreviousPage}
        disabled={startIndex <= 0}
      >
        <Icon icon="carbon:previous-filled" color={startIndex <= 0 ? 'grey' : 'black'} width="24" height="24" style={NaviconStyle} />
      </button>
      {/* Next Button */}
      <button
        style={endIndex >= filteredDomains.length ? disabledNxtNavButtonStyle : NxtNavbuttonStyle}
        onClick={handleNextPage}
        disabled={endIndex >= filteredDomains.length}
      >
        <Icon icon="carbon:next-filled" color={endIndex >= filteredDomains.length ? 'grey' : 'black'} width="24" height="24" style={NaviconStyle} />
      </button>
      </div>
    
          <h4>{selectedCategory ? `` : 'General'}</h4>
          {renderDomainList({ showGeneralButton })}
          <p></p>
        </>
      )}
      
    </div>
    {/* This is reserved to see users. 
    <div>
      <h1>Marketplace</h1>
      <ul>
        {users.map((user) => (
          <li key={user.id}>
            <Link to={`/profile/${user.id}`}>View Profile</Link>
          </li>
        ))}
      </ul>
        </div>
        <div>
    <button onClick={handleRefresh} >
  <Icon icon="mingcute:down-fill" color="black" width="19" height="19" style={NaviconStyle}/> 
    </button>
    </div>
        */}
     
   
    </div> 

    );
  }
  
  
  export default Marketplace;
